import { render, staticRenderFns } from "./TheCollectionsModal.vue?vue&type=template&id=61a5a0b7"
import script from "./TheCollectionsModal.vue?vue&type=script&lang=js"
export * from "./TheCollectionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports